module.exports = __webpack_public_path__ + "static/media/head-porto.2e3310fb.png";